export default "__VITE_PUBLIC_ASSET__fad0a563__"